import Api from '../functions/api';
import { serialize } from '../functions/objectToQuery';

const aprovar = (protocolo) => {
  return Api.put(`/Solicitacao/${protocolo}/Aprovar`);
};

const criar = (body) => {
  return Api.post('/Solicitacao', body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const editar = (protocolo, body) => {
  return Api.put(`/Solicitacao/${protocolo}`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const obterFiltrado = (params) => {
  return Api.get(`/Solicitacao/?${serialize(params)}`);
};
const obterPorProtocolo = (protocolo) => {
  return Api.get(`/Solicitacao/${protocolo}`);
};

const reprovar = (protocolo, body) => {
  return Api.put(`/Solicitacao/${protocolo}/Reprovar`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const SolicitacaoStore = {
  aprovar,
  criar,
  editar,
  obterFiltrado,
  obterPorProtocolo,
  reprovar,
};
